/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { IoCloseSharp } from 'react-icons/io5';
import Holon from '../Buttons/holon';
import Dropdown from '../Buttons/dropdown';
import { vrsSummation } from '../../utils/objectHelpers';
import { dateRange } from '../../utils/dateHelpers';
import DateRange from '../Common/dateRange';
import { allows } from '../../utils/authorization';

class DetailHeader extends React.Component {
  handleWorkPackageDelete = () => {
    this.props.handleDelete(this.props.target.id);
    this.props.onClose();
  };

  handleWorkPackageRestore = () => {
    this.props.handleRestore(this.props.target.id);
    this.props.onClose();
  };

  validStartDate = (currentDate, selectedDate) =>
    (selectedDate || currentDate).isSameOrBefore(this.props.target.end_date);

  validEndDate = (currentDate, selectedDate) =>
    (selectedDate || currentDate).isSameOrAfter(this.props.target.start_date);

  formatDate = (date) => {
    let splitDate;

    if (!date) return '';
    if (date._i) splitDate = date._i.split('-');
    else if (!date._i && date._isAMomentObject) return '';
    else splitDate = date.split('-');

    const year = splitDate.shift();
    splitDate.push(year.slice(2));
    return splitDate.join('/');
  };

  render() {
    const { target, stories, onClose, handleUpdate, isValid } = this.props;
    const vrsSum = vrsSummation(stories);
    const allowEdit = target.id ? allows('update', target) : true;
    const allowDelete = allows('destroy', target);
    const allowRestore = allows('restore_targets', target);

    return (
      <div className="target-detail-header">
        <div className="dropdown-container">
          <Dropdown
            handleDelete={this.handleWorkPackageDelete}
            handleRestore={this.handleWorkPackageRestore}
            allowEdit={target.id ? allowEdit : false}
            allowDelete={allowDelete}
            allowRestore={allowRestore}
            deleted={target.deleted_at}
          />
        </div>

        <div className="dates">
          {allowEdit ? (
            <DateRange
              startDate={this.formatDate(target.start_date)}
              endDate={this.formatDate(target.end_date)}
              onDateChange={handleUpdate}
              validStart={this.validStartDate}
              validEnd={this.validEndDate}
              isValid={isValid}
            />
          ) : (
            <strong className="modal-title">{dateRange(target)}</strong>
          )}
        </div>
        <div className="holon text-center">
          <div className="center holon-wrapper">
            <Holon />
          </div>
        </div>
        <div className="form-inline text-center">
          <div>
            <div className="vrs">
              <div className="value vrs-title center">
                Value - {vrsSum.value}
              </div>
              <div className="risk vrs-title center">Risk - {vrsSum.risk}</div>
              <div className="points vrs-title center">
                Points - {vrsSum.size}
              </div>
              {target.id ? (
                <div className="detail-close">
                  <button type="button" className="btn-close" onClick={onClose}>
                    <IoCloseSharp size="2em" />
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DetailHeader.propTypes = {
  handleUpdate: PropTypes.func,
  handleDelete: PropTypes.func,
  onClose: PropTypes.func,
  target: PropTypes.object,
  stories: PropTypes.array
};

export default DetailHeader;
